import React, { useEffect } from "react"
import Layout from "~/components/Layout";
import { useLang } from "~/hooks/useLang";
import AuditKeywordstable from "../components/Keywords";

export default function AuditKeywords() {
    const { translate } = useLang();

    useEffect(() => {
        document.title = translate('Keyword Audit - Dispatch System')
    }, [])
    return (
        <Layout marginLayout={true}>
            <AuditKeywordstable />
        </Layout>
    )
}